import React from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const ArrowDownIcon: React.FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props} data-test-id="arrow-down-icon">
    <path d="M15.293 27.707a1 1 0 0 0 1.414 0l8.5-8.5a1 1 0 0 0-1.414-1.414L17 24.586V5a1 1 0 1 0-2 0v19.586l-6.793-6.793a1 1 0 0 0-1.414 1.414l8.5 8.5Z" />
  </BaseIcon>
);
